import { render, staticRenderFns } from "./documentViewing.vue?vue&type=template&id=0bcf4621&scoped=true&"
import script from "./documentViewing.vue?vue&type=script&lang=js&"
export * from "./documentViewing.vue?vue&type=script&lang=js&"
import style0 from "./documentViewing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./documentViewing.vue?vue&type=style&index=1&id=0bcf4621&lang=scss&scoped=true&"
import style2 from "./documentViewing.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf4621",
  null
  
)

component.options.__file = "documentViewing.vue"
export default component.exports